/* ==========================================================================
   Winksleep LUXE — landing page behaviour
   --------------------------------------------------------------------------
   EVERYTHING EDITABLE LIVES IN THE `LUXE` OBJECT BELOW.
   Copy, product data, layer data, chooser routing and image paths are all
   one-line edits. Nothing below the CONFIG block needs touching to change
   wording, prices, models or imagery.
   ========================================================================== */

var LUXE = window.WINKSLEEP_LUXE_CONFIG || {

  /* ---- IMAGE SLOTS ------------------------------------------------------
     Drop the real files into /assets/ using these names and they appear
     automatically. Until then each slot shows a labelled grey placeholder at
     the correct aspect ratio, so nothing shifts when you add them.
     MOCKUP NOTE: AI/placeholder imagery must be replaced with real product
     photography before launch — it must never be used as purchase proof.
     --------------------------------------------------------------------- */
  assets: {
    // These six are stills pulled from your own hero footage as on-brand
    // stand-ins (frames 165, 120, 108 and 239). To swap in the real
    // photography, drop the file in and change the extension here — one line
    // each. Everything below them is still awaiting a real shoot.
    packshot:      { src:'assets/product-packshot.webp',        alt:'The Winksleep LUXE mattress, three-quarter view',           label:'PRODUCT PACKSHOT — 2000×1125' },
    packshotSquare:{ src:'assets/product-packshot-square.webp', alt:'The Winksleep LUXE mattress on a cream background',         label:'PRODUCT PACKSHOT — 2000×2000' },
    mayfairNatural2000:    { src:'assets/mayfair-natural-2000.webp',             alt:'WinkSleep LUXE Mayfair Natural 2000 mattress',                 label:'MAYFAIR NATURAL 2000' },
    heritageNatural1500:   { src:'assets/heritage-natural-1500.webp',            alt:'WinkSleep LUXE Heritage Natural 1500 mattress',                label:'HERITAGE NATURAL 1500' },
    westminsterNatural3000:{ src:'assets/westminster-natural-3000.webp',         alt:'WinkSleep LUXE Westminster Natural 3000 mattress',             label:'WESTMINSTER NATURAL 3000' },
    sovereignMemory2000:   { src:'assets/sovereign-memory-2000.webp',            alt:'WinkSleep LUXE Sovereign Memory 2000 mattress',                label:'SOVEREIGN MEMORY 2000' },
    imperialMemory1500:    { src:'assets/imperial-memory-pillow-top-1500.webp',  alt:'WinkSleep LUXE Imperial Memory Pillow Top 1500 mattress',      label:'IMPERIAL MEMORY PILLOW TOP 1500' },
    kensingtonGel1500:     { src:'assets/kensington-gel-1500.webp',              alt:'WinkSleep LUXE Kensington Gel 1500 mattress',                  label:'KENSINGTON GEL 1500' },
    royalGel2000:          { src:'assets/royal-gel-pillow-top-2000.webp',        alt:'WinkSleep LUXE Royal Gel Pillow Top 2000 mattress',            label:'ROYAL GEL PILLOW TOP 2000' },
    juniorSovereign:       { src:'assets/junior-sovereign.webp',                 alt:'WinkSleep LUXE Junior Sovereign mattress',                     label:'JUNIOR SOVEREIGN' },
    spendSaveBadge:        { src:'assets/spend-save-badge.webp',                 alt:'WinkSleep Spend and Save — save up to £100',                   label:'SPEND & SAVE' },
    layersFront:   { src:'assets/layers-exploded.webp',         alt:'The LUXE mattress separated into its component layers',     label:'EXPLODED CONSTRUCTION — 1920×1080' },
    layersAngled:  { src:'assets/layers-exploded-angled.webp',  alt:'The LUXE layers separated, three-quarter view',             label:'EXPLODED CONSTRUCTION (ANGLED) — 1920×1080' },
    lifestyle:     { src:'assets/rested-poster.webp',           alt:'A woman resting comfortably in a bright white bed',         label:'LIFESTYLE VIDEO POSTER — 1600×900' },
    springsMacro:  { src:'assets/springs-macro.webp',           alt:'Close detail of Adaptive Core pocket springs',              label:'ADAPTIVE CORE MACRO — 1920×1080' },
    // Labelled cutaway. Its torn white margin has been knocked out to
    // transparent so it merges into the section's #ECE2D9 panel.
    coreDiagram:   { src:'assets/adaptive-core-coils.webp',     alt:'Close-up of individually wrapped Adaptive Core pocket springs', label:'ADAPTIVE CORE POCKET SPRINGS — 941×1672' },
    fillingsMacro: { src:'assets/fillings-macro.png',          alt:'Layered wool, silk, cashmere and cotton fillings',          label:'NATURAL FILLINGS MACRO — 1200×1200' },
    gelMacro:      { src:'assets/gel-macro.png',               alt:'The cooling gel comfort layer',                             label:'COOLING GEL MACRO — 1200×1200' },
    foamMacro:     { src:'assets/foam-macro.png',              alt:'Memory foam recovering from a hand press',                  label:'MEMORY FOAM MACRO — 1200×1200' },
    stitchDetail:  { src:'assets/stitch-detail.png',           alt:'Tufting and edge piping on the natural cover',              label:'STITCHING / TUFTING — 1600×1000' },
    // Real factory photography — the Dewsbury workshop, hand-tufting to order.
    factory:       { src:'assets/factory.webp',                alt:'Winksleep makers hand-tufting a mattress in the Dewsbury workshop', label:'CRAFT / FACTORY — 1200×1500' },
    factoryWide:   { src:'assets/factory-wide.webp',           alt:'The Winksleep workshop floor in Dewsbury',                  label:'CRAFT / FACTORY — 1600×1000' }
  },

  /* ---- HERO -------------------------------------------------------------
     Caption timings are ORIGINAL source frame numbers (0–239), converted to
     timeline progress at runtime — so the same numbers hold for the desktop
     set (240 frames) and the mobile set (120).
     --------------------------------------------------------------------- */
  hero: {
    desktop: { count:240, path:function(i){ return 'frames/hero_' + String(i).padStart(3,'0') + '.webp'; } },
    mobile:  { count:120, path:function(i){ return 'frames-mobile/hero_' + String(i).padStart(3,'0') + '.webp'; } },
    sourceFrameCount: 240,
    scrollVh: 720,          // scroll length of the pinned hero, in vh. Longer =
                            // more scroll distance per frame, so the scrub reads
                            // smoother and each caption holds longer.
    scrubSmoothing: 0.6,    // `true` = 1:1 and snappier; 0.4–0.8 = smoother
    maxDPR: 2,
    maxBackingWidth: 2000,  // source frames are 1600px — a bigger buffer only costs fill rate
    mobileBreakpoint: 900,  // mirrored in the <picture> media query on the poster
    decodeTimeoutMs: 1500,
    maxPreloadMs: 20000,
    containBelowAspect: 0.72,
    captionDriftPx: 10,
    captions: [
      { pos:'brand', arrow:true, fadeOut:[34,48],
        title:  'Sleep',
        tagline:'…but not as you\nknow it…',
        // The tagline and its arrow are the opening aside — they clear almost
        // as soon as you start scrolling, leaving the statement on its own.
        taglineFadeOut:[2,16],
        sub:    'Unlock Deeper comfort.\nSmarter support & Better mornings.' },
      { pos:'right-lower', size:'sm', panel:true, fadeIn:[74,94], fadeOut:[126,142],
        title:'Introduce yourself to Adaptive Core Technology…',
        sub:  'Responsive springs that are designed to totally support you.' },
      { pos:'right-lower', size:'sm', panel:true, fadeIn:[144,160], fadeOut:[182,198],
        title:'Support where it matters.\nComfort everywhere else.' },
      // The closing statement is fixed inside the hero stage and fades in near
      // the final frames without translating or scaling.
    ],

    /* ---- CLOSING LOCKUP ------------------------------------------------ */
    closing: {
      startFrame:197,
      fadeFrames:18
    }
  },

  /* ---- 6 · LIFESTYLE BACKGROUND VIDEO -----------------------------------
     Always muted — there is no sound anywhere on this page.
     --------------------------------------------------------------------- */
  lifestyleVideo: {
    src: 'assets/rested.mp4',
    minWidth: 899,     // at or below this width the poster is used instead
    crossfadeS: 0.7    // seconds of dissolve either side of the loop join
  },

  /* ---- 3 · THE PROBLEM ------------------------------------------------- */
  problems: [
    { q:'Waking up uncomfortable',      a:'Adaptive body support keeps your spine in line, whichever way you sleep.', icon:'alignment' },
    { q:'Overheating at night',         a:'A cooling gel comfort layer draws warmth away from the surface.', icon:'cooling' },
    { q:'Feeling your partner move',    a:'Individually pocketed springs absorb movement instead of passing it on.', icon:'motion' },
    { q:'Not knowing which to choose',  a:'Use our mattress finder to help solve your sleep.', icon:'finder' }
  ],

  /* ---- 4 · THE CONSTRUCTION -------------------------------------------
     Layer count and order are editable — different LUXE models build
     differently. `image` is optional; without one the band shows its name.
     --------------------------------------------------------------------- */
  // `ar` is the strip's own width:height. Each band is drawn at that ratio, so
  // the bands' relative thicknesses on screen are the real ones from the photos.
  layers: [
    { name:'Natural Comfort Fillings',     desc:'Wool, silk, cashmere and cotton for a soft, breathable surface.',                                  benefit:'Breathable comfort',   src:'assets/layer-fillings.webp', ar:11.949 },
    { name:'Cooling Gel Comfort Layer',    desc:'Draws warmth away from the surface for a fresher feel through the night.',                          benefit:'Cooler sleep',         src:'assets/layer-gel.webp',      ar:16.791 },
    { name:'Pressure-Relieving Memory Foam',desc:'Contours to shoulders and hips so pressure points have somewhere to go.',                          benefit:'Pressure relief',      src:'assets/layer-foam.webp',     ar:16.901 },
    { name:'Adaptive Core™ Pocket Springs', desc:'Springs respond independently to weight and movement, supporting the body while reducing partner disturbance.', benefit:'Independent support', src:'assets/layer-core.webp', ar:6.131 },
    { name:'Reinforced Base & Edge',       desc:'Stable support right to the edge, so the whole surface is usable.',                                 benefit:'Edge to edge',         src:'assets/layer-base.webp',     ar:7.601 }
  ],
  layerGap: 0.05,   // separation between bands, as a fraction of the stack width

  /* ---- 5 · HERO INGREDIENT --------------------------------------------- */
  ingredient: {
    name:'Adaptive Core™ Pocket Springs',
    // One list — every block is a label plus a single sentence.
    details:[
      { label:'What it is',           text:'Individually pocketed springs that respond independently.' },
      { label:'What you feel',        text:'Balanced support that follows your body.' },
      { label:'What it solves',       text:'Less stiffness. Less partner disturbance. Better sleep.' },
      { label:'Moves with you',       text:'Shoulders and hips sink naturally while your body stays supported.' },
      { label:'Keeps movement local', text:'Movement stays on one side of the bed, so you both sleep soundly.' },
      { label:'Holds its shape',      text:'Springs recover night after night for lasting comfort.' }
    ],
    image:'coreDiagram',
    linkLabel:'Explore mattresses with Adaptive Core™',
    linkHref:'#comparison'
  },

  /* ---- 7 · BENEFITS ----------------------------------------------------- */
  benefits: [
    { icon:'support', t:'Adaptive body support',      d:'Support that responds to weight and shape, not a single fixed firmness.' },
    { icon:'moon',    t:'Reduced partner disturbance',d:'Pocketed springs keep one person’s movement from becoming both people’s problem.' },
    { icon:'snow',    t:'Cooling comfort',            d:'Breathable natural fibres and a gel layer that moves heat away from the surface.' },
    { icon:'leaf',    t:'Natural materials',          d:'Wool, silk, cashmere and cotton — chosen for comfort and for how they age.' },
    { icon:'hand',    t:'Hand-built in the UK',       d:'Made to order by people who have been building beds for nearly forty years.' },
    { icon:'truck',   t:'Full-build delivery',        d:'Delivered fully built by a specialist two-person team. Never rolled into a box.' }
  ],

  /* ---- 8 · THE RANGE ----------------------------------------------------
     PRICES ARE PLACEHOLDERS — replace with Shopify variant pricing.
     --------------------------------------------------------------------- */
  products: [
    { id:'mayfair-natural-2000',    name:'Mayfair Natural 2000',        best:'Natural materials with a balanced, everyday feel.',   feel:'Medium-firm', depth:'28cm', springs:'2000',       material:'Wool, silk & cotton',   cooling:'High',      motion:'Low',      from:'£1,249', sizes:['Single','Double','King','Super King'], image:'mayfairNatural2000', lead:true },
    { id:'heritage-natural-1500',   name:'Heritage Natural 1500',       best:'A first step into natural fillings.',                 feel:'Medium-firm', depth:'25cm', springs:'1500',       material:'Wool & cotton',         cooling:'Medium',    motion:'Low',      from:'£949',   sizes:['Single','Double','King','Super King'], image:'heritageNatural1500' },
    { id:'westminster-natural-3000',name:'Westminster Natural 3000',    best:'Firmer support and the deepest natural build.',       feel:'Firm',        depth:'32cm', springs:'3000',       material:'Wool, silk & cashmere', cooling:'High',      motion:'Very low', from:'£1,899', sizes:['Double','King','Super King'],         image:'westminsterNatural3000' },
    { id:'sovereign-memory-2000',   name:'Sovereign Memory 2000',       best:'Pressure relief for shoulders and hips.',             feel:'Medium',      depth:'29cm', springs:'2000',       material:'Memory foam',           cooling:'Medium',    motion:'Very low', from:'£1,349', sizes:['Single','Double','King','Super King'], image:'sovereignMemory2000' },
    { id:'imperial-memory-pt-1500', name:'Imperial Memory Pillow Top 1500', best:'Softer, deeper comfort with a pillow top.',       feel:'Medium-soft', depth:'31cm', springs:'1500',       material:'Memory foam',           cooling:'Medium',    motion:'Low',      from:'£1,149', sizes:['Double','King','Super King'],         image:'imperialMemory1500' },
    { id:'kensington-gel-1500',     name:'Kensington Gel 1500',         best:'A cooler night without changing the feel.',           feel:'Medium-firm', depth:'27cm', springs:'1500',       material:'Cooling gel',           cooling:'Very high', motion:'Low',      from:'£1,049', sizes:['Single','Double','King','Super King'], image:'kensingtonGel1500' },
    { id:'royal-gel-pt-2000',       name:'Royal Gel Pillow Top 2000',   best:'The coolest sleep in the range.',                     feel:'Medium',      depth:'32cm', springs:'2000',       material:'Cooling gel',           cooling:'Very high', motion:'Very low', from:'£1,549', sizes:['Double','King','Super King'],         image:'royalGel2000' }
  ],

  promotion: {
    title:'Save up to £100',
    endsAt:'2026-08-31T23:59:59+01:00',
    endsLabel:'Ends 31 August at 11:59pm',
    tiers:['Spend £250 · Save £25','Spend £500 · Save £50','Spend £750 · Save £75','Spend £1,000 · Save £100'],
    href:'#purchase'
  },

  /* ---- 9 · CHOOSER ------------------------------------------------------
     No email, no name, no age/height/weight. Runs entirely in the browser.
     Routing lives in `recommendations` — edit there, not in the logic.
     --------------------------------------------------------------------- */
  chooser: {
    questions:[
      { key:'position', q:'How do you normally sleep?',
        options:[ {label:'On my side'}, {label:'On my back'}, {label:'On my front'}, {label:'I move around'} ] },
      { key:'priority', q:'What matters most?',
        options:[
          {label:'Cooler sleep',            route:'hot'},
          {label:'Pressure relief',         route:'pressure'},
          {label:'Less partner movement',   route:'pressure'},
          {label:'Natural materials',       route:'natural'},
          {label:'Firmer support',          route:'firm'},
          {label:'Softer, deeper comfort',  route:'pressure'}
        ] },
      { key:'feel', q:'Which feel do you prefer?',
        options:[ {label:'Medium-firm'}, {label:'Firm', route:'firm'}, {label:'Not sure'} ] },
      { key:'who', q:'Who is it for?',
        options:[ {label:'Just me'}, {label:'Me & my partner'}, {label:'A child', junior:true}, {label:'A guest room'} ] }
    ],
    // Q3 "Firm" overrides Q2; otherwise Q2's route wins. Default = natural.
    defaultRoute:'natural',
    recommendations:{
      natural:{
        product:'mayfair-natural-2000', alt:'heritage-natural-1500',
        reasons:[ 'Natural wool, silk and cotton keep the surface breathable.',
                  '2000 Adaptive Core™ springs balance support and give.',
                  'A medium-firm feel that suits most sleeping positions.' ] },
      hot:{
        product:'royal-gel-pt-2000', alt:'kensington-gel-1500',
        reasons:[ 'A cooling gel layer moves heat away from the surface.',
                  'A pillow top adds softness without trapping warmth.',
                  '2000 pocket springs keep airflow moving through the core.' ] },
      pressure:{
        product:'sovereign-memory-2000', alt:'imperial-memory-pt-1500',
        reasons:[ 'Memory foam contours to shoulders and hips.',
                  'Pocket springs stop movement travelling across the bed.',
                  'A medium feel that relieves pressure without feeling soft.' ] },
      firm:{
        product:'westminster-natural-3000', alt:'mayfair-natural-2000',
        reasons:[ '3000 springs give the firmest support in the range.',
                  'A deep 32cm natural build that holds its shape.',
                  'Reinforced edges keep the whole surface usable.' ] }
    },
    juniorNote:'Shopping for a child? The Junior Sovereign is built for growing bodies — ask us about it.'
  },

  /* ---- 10 · TRUSTPILOT TESTIMONIALS ------------------------------------ */
  proof: {
    logo:'assets/trustpilot-logo.png',
    autoplayMs:5000,
    reviews:[
      { name:'Zeshan Abid', country:'GB', count:'3 reviews', date:'2 days ago', title:'I’m very happy with the bed and…', quote:'I’m very happy with the bed and mattress. The bed is sturdy and well-made, while the mattress is comfortable and provides great support for a good night’s sleep. Excellent quality and good value for money. Highly recommended!', avatar:'assets/avatar-two.webp', userUrl:'https://uk.trustpilot.com/users/64cbf3f29dc4370012b12c9b', reviewUrl:'https://uk.trustpilot.com/reviews/6a6fbc2d80b5770ef9c4b8b3' },
      { name:'Alison west', country:'GB', count:'8 reviews', date:'Jul 22, 2026', title:'Very easy purchase process', quote:'Very easy purchase process, very prompt delivery, great product at great price. Very happy.', avatar:'assets/avatar-one.webp', userUrl:'https://uk.trustpilot.com/users/60c1d1125829a90019e577e2', reviewUrl:'https://uk.trustpilot.com/reviews/6a60d843a3c5074fe7316b69' },
      { name:'Lou Price', country:'GB', count:'1 review', date:'Jun 23, 2026', title:'Best bed I’ve ever had', quote:'Best bed I’ve ever had, I’ve got the Elegance ottoman and the storage is amazing. The delivery guys were so nice and helpful and the bed is great quality.', avatar:'assets/avatar-four.webp', userUrl:'https://uk.trustpilot.com/users/68f7a50fabede2f6c4da5953', reviewUrl:'https://uk.trustpilot.com/reviews/6a3a55a87f05789e39d97285' },
      { name:'Leah b', country:'GB', count:'3 reviews', date:'Jun 22, 2026', title:'Great experience', quote:'Great experience, two beds ordered for our main bedroom and guest bedroom, the quality is a* and we’re so pleased we went for ottoman storage.', avatar:'assets/avatar-three.webp', userUrl:'https://uk.trustpilot.com/users/6321fcbaf2a8b90013fadbb2', reviewUrl:'https://uk.trustpilot.com/reviews/6a39801133278580a102bf7e' },
      { name:'Danielle', country:'GB', count:'24 reviews', date:'Jun 22, 2026', title:'We ordered the Dusk & Dawn Luxe Haven…', quote:'We ordered the Dusk & Dawn Luxe Haven Bed Frame and it was the perfect choice for our room. Ordered in plush velvet, ordering online was easy and delivery was quicker than we anticipated. Would recommend winskleep.', avatar:'assets/avatar-five.webp', userUrl:'https://uk.trustpilot.com/users/5f63568947938ffbcf03e119', reviewUrl:'https://uk.trustpilot.com/reviews/6a397ed9fa0baaa84033a798' }
    ]
  },

  /* ---- 12 · REASSURANCE — closes the page ------------------------------- */
  reassurance: [
    { icon:'truck',  t:'Delivered fully built',     d:'A specialist two-person team brings it in and sets it up. Never rolled.' },
    { icon:'card',   t:'Klarna 0% finance',         d:'Spread the cost over interest-free instalments at checkout.' },
    { icon:'shield', t:'Five-year warranty',        d:'Manufacturer’s guarantee on every LUXE mattress.' },
    { icon:'return', t:'Trial & returns',           d:'[PLACEHOLDER — confirm trial length and returns terms]' }
  ],

  /* ---- 13 · PURCHASE BLOCK ----------------------------------------------
     PRICES / SAVINGS ARE PLACEHOLDERS — wire to Shopify variants.
     --------------------------------------------------------------------- */
  purchase: {
    productId:'mayfair-natural-2000',
    badge:'Recommended',
    points:[ 'Natural wool, silk and cotton fillings',
             '2000 Adaptive Core™ pocket springs',
             'Hand-built to order and delivered fully built' ],
    priceNow:'£1,249', priceWas:'£1,649', saving:'Save £400',
    finance:'From £104.08/month with Klarna. 0% APR representative.',
    delivery:'Free two-person delivery, typically 10–14 days.',
    warranty:'Five-year manufacturer’s warranty.',
    productHref:'#'
  },

  /* ---- 15 · FAQ ---------------------------------------------------------
     Only entries with approved:true are published (and only those go into the
     JSON-LD). Flip approved to false to hold one back for legal sign-off.
     --------------------------------------------------------------------- */
  faqs: [
    { q:'Which LUXE mattress is right for me?',        a:'The 60-second chooser above narrows the range to one recommendation and one alternative, based on how you sleep and what matters most to you.', approved:true },
    { q:'Are they really made in the UK?',             a:'Yes. Every LUXE mattress is hand-built to order in our UK workshop.', approved:true },
    { q:'Do they arrive rolled up in a box?',          a:'No. LUXE mattresses are delivered fully built by a two-person team and carried to the room you want them in.', approved:true },
    { q:'What is Adaptive Core™?',                     a:'It is our pocket spring system. Each spring sits in its own fabric pocket so it can respond independently to weight and movement — supporting your body while keeping a partner’s movement from travelling across the bed.', approved:true },
    { q:'Which is best for hot sleepers?',             a:'The Royal Gel Pillow Top 2000 is the coolest in the range, with the Kensington Gel 1500 close behind. Both use a cooling gel comfort layer.', approved:true },
    { q:'Which is best for couples?',                  a:'Any model with a higher spring count will reduce partner disturbance. The Westminster Natural 3000 and Sovereign Memory 2000 perform best.', approved:true },
    { q:'What natural materials do you use?',          a:'Wool, silk, cashmere and cotton, depending on the model. Each is listed on the product page.', approved:true },
    { q:'I sleep on my side — what firmness do I need?',a:'Side sleepers usually prefer medium to medium-firm, so the shoulder and hip can sink while the spine stays level.', approved:true },
    { q:'What sizes are available?',                   a:'Single, Double, King and Super King across most of the range. Deeper models start at Double.', approved:true },
    { q:'What does the warranty cover?',               a:'A five-year manufacturer’s warranty against defects in materials and workmanship.', approved:true },
    { q:'Do you offer finance?',                       a:'Yes — Klarna 0% finance is available at checkout, subject to status.', approved:true },
    { q:'How long does delivery take?',                a:'Typically 10–14 days, as each mattress is made to order. You will be given a delivery window in advance.', approved:true },
    { q:'What is your returns policy?',                a:'[PLACEHOLDER — awaiting approved returns and trial wording]', approved:false }
  ],

  /* ---- 16 · FOOTER ------------------------------------------------------- */
};


/* ==========================================================================
   Everything below is machinery. Editing copy/data above is enough.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasGSAP = !!(window.gsap && window.ScrollTrigger);
  var animate = hasGSAP && !reduceMotion;

  if (hasGSAP) gsap.registerPlugin(ScrollTrigger);

  /* ---- Tracking ---------------------------------------------------------
     Stubbed. Wire the destination here (GA4 / GTM / Shopify analytics).
     NOTE: chooser answers describe sleep habits. They are flagged
     nonAdvertising and must NOT be forwarded to ad platforms.
     --------------------------------------------------------------------- */
  window.dataLayer = window.dataLayer || [];
  function track(event, payload) {
    var data = Object.assign({ event: event }, payload || {});
    window.dataLayer.push(data);
    // TODO: forward to analytics destination. Respect data.nonAdvertising.
    if (window.console && console.debug) console.debug('[track]', event, data);
  }
  window.track = track;

  /* ---- Small helpers ---------------------------------------------------- */
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function productById(id) {
    for (var i = 0; i < LUXE.products.length; i++) if (LUXE.products[i].id === id) return LUXE.products[i];
    return null;
  }

  function assetUrl(path) {
    if (!path) return '';
    path = String(path);
    if (/^(https?:)?\/\//.test(path) || path.charAt(0) === '/' || /^data:|^blob:/.test(path)) return path;
    var base = LUXE.assetBase || '';
    return base + path.replace(/^assets\//, '');
  }
  function framePath(set, i) {
    if (typeof set.path === 'function') return assetUrl(set.path(i));
    var n = String(i).padStart(3, '0');
    return assetUrl((set.prefix || '') + n + (set.suffix || '.webp'));
  }
  function productUrl(product) {
    var href = product && product.url;
    if (href) return href;
    href = LUXE.purchase && LUXE.purchase.productHref;
    if (href && href.charAt(0) === '#') {
      var target = document.getElementById(href.slice(1));
      if (!target || target.hidden) href = '';
    }
    return href || '#';
  }

  var ICONS = {
    tick:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M4 12.5l5 5L20 6.5"/></svg>',
    support:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M2 15c3-4 6-6 10-6s7 2 10 6"/><path d="M2 19h20"/></svg>',
    moon:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M20 14A8 8 0 019.5 3.5 8.5 8.5 0 1020 14z"/></svg>',
    snow:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M12 2v20M4 6l16 12M20 6L4 18"/></svg>',
    leaf:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M4 20C4 10 12 4 21 4c0 9-6 16-16 16H4z"/><path d="M4 20c4-6 9-9 13-10"/></svg>',
    hand:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M8 12V5a1.5 1.5 0 013 0v6"/><path d="M11 11V4a1.5 1.5 0 013 0v7"/><path d="M14 11V6a1.5 1.5 0 013 0v8c0 4-2.5 7-6.5 7S4 18 4 14v-2a1.5 1.5 0 013 0"/></svg>',
    truck:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M2 7h11v9H2zM13 10h4l3 3v3h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>',
    card:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M12 2l8 3v7c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V5z"/></svg>',
    return: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M3 12a9 9 0 109-9"/><path d="M3 4v5h5"/></svg>'
  };
  function icon(name, cls) {
    return '<span class="' + (cls || '') + '" aria-hidden="true">' + (ICONS[name] || '') + '</span>';
  }

  var PROBLEM_ICONS = {
    alignment:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><circle cx="13" cy="13" r="5"/><path d="M8 39h32M10 34c4-6 8-10 14-10 7 0 10 4 14 10"/><path d="M20 20c2 0 4 1 6 3"/><path d="M25 25c1.5 1.5 2.5 3.5 2.5 6" stroke-dasharray="2.5 3"/><path d="M24 17v4M24 33v4"/></svg>',
    cooling:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><path d="M24 6v25M13 12l22 13M35 12L13 25M18 9l6 5 6-5M18 28l6-5 6 5"/><path d="M8 37c4-3 8-3 12 0s8 3 12 0 7-3 9-1"/><path d="M11 42c3-2 6-2 9 0s6 2 9 0"/></svg>',
    motion:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 35h36M8 31h32V20H8zM24 20v11"/><circle cx="16" cy="15" r="4"/><circle cx="33" cy="15" r="4"/><path d="M8 11c-3 2-3 6 0 8M4 9c-5 5-5 11 0 16M24 15v21" stroke-dasharray="2 3"/></svg>',
    finder:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><circle cx="21" cy="21" r="12"/><path d="M30 30l10 10M16 18c1-3 3-5 6-5 4 0 6 2 6 5 0 5-6 5-6 9M22 32h.01"/></svg>'
  };

  var CHOOSER_ICONS = {
    position: {
      'On my side':'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 35h38M8 31h8l3-8c1-4 5-6 9-4l7 4c3 2 5 5 5 8"/><circle cx="15" cy="18" r="5"/><path d="M21 26l8 2 5 3"/></svg>',
      'On my back':'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 35h38M8 31h32M15 31l4-10h10l4 10"/><circle cx="24" cy="14" r="5"/><path d="M24 21v8M18 24l-4 5M30 24l4 5"/></svg>',
      'On my front':'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 35h38M8 31h32M13 27c5-5 17-6 23 0l4 4H9z"/><circle cx="17" cy="22" r="4"/><path d="M22 24h11"/></svg>',
      'I move around':'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><path d="M37 18a15 15 0 00-25-3l-3 4M11 11v8h8M11 30a15 15 0 0025 3l3-4M37 37v-8h-8"/><path d="M19 29c7 2 12-3 13-10-7-1-13 3-13 10z"/></svg>'
    },
    priority: {
      'Cooler sleep':ICONS.snow,
      'Pressure relief':ICONS.hand,
      'Less partner movement':ICONS.moon,
      'Natural materials':ICONS.leaf,
      'Firmer support':ICONS.support,
      'Softer, deeper comfort':ICONS.moon
    },
    feel: {
      'Medium-firm':ICONS.support,
      'Firm':ICONS.shield,
      'Not sure':ICONS.moon
    },
    who: {
      'Just me':'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><circle cx="24" cy="15" r="7"/><path d="M11 39c1-9 6-14 13-14s12 5 13 14"/></svg>',
      'Me & my partner':'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><circle cx="17" cy="16" r="6"/><circle cx="32" cy="16" r="6"/><path d="M6 39c1-9 5-14 11-14 4 0 7 2 9 6M42 39c-1-9-5-14-10-14-4 0-7 2-9 6"/></svg>',
      'A child':'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><path d="M24 6l4.5 10 11 .9-8.4 7.3 2.6 10.8L24 29.5 14.3 35l2.6-10.8-8.4-7.3 11-.9z"/></svg>',
      'A guest room':'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 23L24 8l17 15v18H7z"/><path d="M18 41V28h12v13M13 20h22"/></svg>'
    }
  };
  function chooserIcon(question, label) {
    var svg = CHOOSER_ICONS[question] && CHOOSER_ICONS[question][label];
    return '<span class="chooser__option-icon" aria-hidden="true">' + (svg || ICONS.moon) + '</span>';
  }

  /* ---- Media slots ------------------------------------------------------
     Shows a labelled placeholder at the right aspect ratio and swaps in the
     real photo only once it has actually loaded. A missing file therefore
     degrades to the placeholder instead of a broken image, with no shift.
     --------------------------------------------------------------------- */
  function mediaSlot(key, aspect, opts) {
    opts = opts || {};
    var spec = LUXE.assets[key] || {};
    var wrap = el('div', 'slot slot--' + (aspect || '169'));
    var ph = el('div', 'placeholder', '<span>' + (spec.label || 'IMAGE') + '</span>');
    wrap.appendChild(ph);
    if (spec.src) {
      var img = new Image();
      img.alt = opts.alt || spec.alt || '';
      img.decoding = 'async';
      if (!opts.eager) img.loading = 'lazy';
      // The image goes into the DOM straight away but transparent. It has to be
      // in the document for lazy-loading to ever fire — a detached lazy image is
      // never "in the viewport", so the browser simply never fetches it.
      img.style.opacity = '0';
      img.addEventListener('load', function () { ph.remove(); img.style.opacity = ''; });
      img.addEventListener('error', function () { img.remove(); });   // placeholder stays
      img.src = assetUrl(spec.src);
      wrap.appendChild(img);
    }
    return wrap;
  }

  /* ======================================================================
     REVEAL SYSTEM — declarative, driven by data attributes.
       [data-reveal]              fade + rise
       [data-reveal="panel"]      materialise (opacity + scale + clip wipe)
       [data-reveal="line"]       display headings, animated in by line
       [data-reveal-group]        staggers its [data-reveal] children
       [data-parallax]            gentle scrubbed travel
     Reduced motion / no GSAP: nothing is hidden, everything just renders.
     ====================================================================== */
  function splitLines(node) {
    // Wrap each word so the browser can still line-break naturally, then
    // animate the words. Avoids measuring lines (which fights web fonts).
    var words = node.textContent.trim().split(/\s+/);
    node.textContent = '';
    return words.map(function (w, i) {
      var outer = el('span', 'reveal-word');
      outer.style.display = 'inline-block';
      outer.style.overflow = 'hidden';
      outer.style.verticalAlign = 'top';
      var inner = el('span', 'reveal-word__inner', w + (i < words.length - 1 ? '&nbsp;' : ''));
      inner.style.display = 'inline-block';
      outer.appendChild(inner);
      node.appendChild(outer);
      return inner;
    });
  }

  function initReveals(root) {
    root = root || document;
    if (!animate) return;

    // Headings first — they need their DOM rewritten before anything animates.
    root.querySelectorAll('[data-reveal="line"]').forEach(function (node) {
      if (node.dataset.revealReady) return;
      node.dataset.revealReady = '1';
      var inners = splitLines(node);
      gsap.set(inners, { yPercent: 110, opacity: 0 });
      gsap.to(inners, {
        yPercent: 0, opacity: 1, duration: 1.1, ease: 'power3.out', stagger: 0.035,
        scrollTrigger: { trigger: node, start: 'top 88%', once: true }
      });
    });

    root.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      if (group.dataset.revealReady) return;
      group.dataset.revealReady = '1';
      // Split headings run their own word animation, so keep them out of the
      // group tween — and claim the rest so the single-element pass skips them.
      var kids = [].filter.call(
        group.querySelectorAll(':scope > [data-reveal], :scope > * > [data-reveal]'),
        function (k) { return k.getAttribute('data-reveal') !== 'line'; }
      );
      if (!kids.length) return;
      kids.forEach(function (k) { k.dataset.revealReady = '1'; });
      gsap.set(kids, { opacity: 0, y: 28 });
      gsap.to(kids, {
        opacity: 1, y: 0, duration: 0.9, ease: 'power3.out', stagger: 0.1,
        scrollTrigger: { trigger: group, start: 'top 85%', once: true }
      });
    });

    root.querySelectorAll('[data-reveal]').forEach(function (node) {
      if (node.dataset.revealReady) return;
      if (node.getAttribute('data-reveal') === 'line') return;
      node.dataset.revealReady = '1';
      var isPanel = node.getAttribute('data-reveal') === 'panel';
      var from = isPanel
        ? { opacity: 0, scale: 0.98, clipPath: 'inset(6% 0% 6% 0%)' }
        : { opacity: 0, y: 28 };
      var to = isPanel
        ? { opacity: 1, scale: 1, clipPath: 'inset(0% 0% 0% 0%)', duration: 1.25, ease: 'power3.out' }
        : { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out' };
      to.scrollTrigger = { trigger: node, start: 'top 88%', once: true };
      gsap.fromTo(node, from, to);
    });

    root.querySelectorAll('[data-parallax]').forEach(function (node) {
      if (node.dataset.parallaxReady) return;
      if (window.matchMedia('(max-width:760px)').matches) return;
      node.dataset.parallaxReady = '1';
      gsap.fromTo(node, { yPercent: -5 }, {
        yPercent: 5, ease: 'none',
        scrollTrigger: { trigger: node.parentElement || node, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
  }

  /* ======================================================================
     HERO — scroll-scrubbed frame sequence on a canvas.
     ====================================================================== */
  function initHero() {
    var H = LUXE.hero;
    var hero = document.getElementById('hero');
    if (!hero) return;
    var luxeRoot = hero.closest('.winksleep-luxe-page') || document.documentElement;

    var isMobile = window.matchMedia('(max-width:' + H.mobileBreakpoint + 'px)').matches;
    var conn = navigator.connection || {};
    var saveData = conn.saveData === true;
    var slowNet = /^(slow-)?2g$/.test(conn.effectiveType || '');
    // Plenty of desktop browsers report '3g' as a conservative default, so it
    // only counts against us on mobile — where bandwidth genuinely matters.
    var modestNet = conn.effectiveType === '3g';
    var lowMemory = typeof navigator.deviceMemory === 'number' && navigator.deviceMemory < 4;

    var useStatic = reduceMotion || !hasGSAP || saveData || slowNet || lowMemory || (isMobile && modestNet);
    var set = isMobile ? H.mobile : H.desktop;

    if (useStatic) return;

    var stage = document.getElementById('heroStage');
    var canvas = document.getElementById('heroCanvas');
    var ctx = canvas.getContext('2d', { alpha: false });
    var frames = new Array(set.count);
    var current = -1;

    function sizeCanvas() {
      var w = stage.clientWidth, h = stage.clientHeight;
      var dpr = Math.min(window.devicePixelRatio || 1, H.maxDPR);
      if (w * dpr > H.maxBackingWidth) dpr = H.maxBackingWidth / w;
      canvas.width = Math.max(1, Math.round(w * dpr));
      canvas.height = Math.max(1, Math.round(h * dpr));
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
    }

    function ready(i) { return frames[i] && frames[i].naturalWidth ? frames[i] : null; }
    function nearest(i) {
      for (var d = 1; d < frames.length; d++) {
        if (ready(i - d)) return frames[i - d];
        if (ready(i + d)) return frames[i + d];
      }
      return null;
    }

    function paint(img) {
      var cw = canvas.width, ch = canvas.height;
      var sw = img.naturalWidth, sh = img.naturalHeight;
      var ir = sw / sh, ar = cw / ch, dw, dh;

      // Viewport much taller than the footage (portrait phones): show the whole
      // frame and fill the bars by stretching its own top and bottom rows —
      // seamless by construction, since each bar meets an edge of its colour.
      // Desktop can preserve the whole cinematic frame with edge-colour fills.
      // On phones, use the normal cover path below so the hero fills the full
      // portrait viewport throughout the scroll instead of becoming a narrow,
      // letterboxed strip with a tiny mattress.
      if (!isMobile && ar / ir < H.containBelowAspect) {
        dw = cw; dh = cw / ir;
        var y0 = Math.round((ch - dh) / 2);
        ctx.drawImage(img, 0, 0, sw, 1, 0, 0, cw, y0 + 1);
        ctx.drawImage(img, 0, sh - 1, sw, 1, 0, y0 + dh - 1, cw, ch - y0 - dh + 1);
        ctx.drawImage(img, 0, y0, dw, dh);
        return;
      }
      if (ar > ir) { dw = cw; dh = cw / ir; }
      else         { dh = ch; dw = ch * ir; }
      ctx.drawImage(img, (cw - dw) / 2, (ch - dh) / 2, dw, dh);
    }

    function render(i) {
      i = Math.max(0, Math.min(set.count - 1, i | 0));
      if (i === current) return;
      var img = ready(i);
      if (img) { current = i; paint(img); return; }
      var sub = nearest(i);
      if (sub) paint(sub);
      current = -1;
    }

    sizeCanvas();

    /* ---- Captions ---- */
    var capLayer = document.getElementById('heroCaptions');

    // Explicit \n becomes a <br> rather than relying on white-space:pre-line,
    // which switches off `text-wrap:balance` — so lines the browser chooses
    // itself stay evened out while authored breaks are still honoured.
    function titleHTML(str) {
      return String(str).split('\n').map(function (line) {
        return line.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }).join('<br>');
    }

    function buildCaption(c, i) {
      var node = capLayer.querySelector('[data-cap="' + i + '"]');
      if (!node) {
        node = el('div'); node.setAttribute('data-cap', i);
        capLayer.appendChild(node);
        node.appendChild(el('p', 'cap__title'));
      }
      node.className = 'cap cap--' + c.pos +
                       (c.size ? ' cap--' + c.size : '') +
                       (c.panel ? ' cap--panel' : '');

      // The opening statement carries its own markup (display line, tagline,
      // arrow) so no-JS still gets it; here we only refresh the text from config.
      var titleEl = node.querySelector('.cap__brandline') || node.querySelector('.cap__title');
      if (titleEl) titleEl.innerHTML = titleHTML(c.title);

      var tag = node.querySelector('.cap__tagline');
      if (tag && c.tagline) tag.innerHTML = titleHTML(c.tagline);

      var sub = node.querySelector('.cap__sub');
      if (c.sub) {
        if (!sub) { sub = el('p', 'cap__sub'); node.appendChild(sub); }
        sub.innerHTML = titleHTML(c.sub);
      } else if (sub) { sub.remove(); }

      var cta = node.querySelector('.cap__cta');
      if (c.cta) {
        if (!cta) { cta = el('a', 'cap__cta'); node.appendChild(cta); }
        cta.href = c.cta.href || '#';
        if (c.cta.logo) {
          cta.className = 'cap__cta cap__cta--logo';
          cta.setAttribute('aria-label', c.cta.label);
          cta.innerHTML = '<img src="' + assetUrl(c.cta.logo) + '" alt="" width="950" height="388">' +
                          '<span class="cap__cta-arrow" aria-hidden="true">→</span>';
        } else {
          cta.className = 'cap__cta';
          cta.textContent = c.cta.label + ' →';
        }
      } else if (cta) { cta.remove(); }
      return node;
    }

    /* ---- Preload behind a gate ---- */
    var loader = document.getElementById('loader');
    var loaderBar = document.getElementById('loaderBar');
    document.body.classList.add('winksleep-luxe-is-loading');
    luxeRoot.classList.add('is-loading');
    loader.hidden = false;
    window.scrollTo(0, 0);

    function loadFrame(i) {
      return new Promise(function (resolve) {
        var img = new Image(), settled = false;
        function done() { if (!settled) { settled = true; resolve(); } }
        img.decoding = 'async';
        img.onload = function () {
          frames[i] = img;
          if (i === 0) { current = -1; render(0); }
          // decode() removes the first-paint hitch, but a hidden tab can leave
          // it pending forever — so it must never gate on its own.
          if (img.decode) {
            var t = setTimeout(done, H.decodeTimeoutMs);
            img.decode().catch(function () {}).then(function () { clearTimeout(t); done(); });
          } else { done(); }
        };
        img.onerror = done;
        img.src = framePath(set, i);
      });
    }

    function preload() {
      return new Promise(function (done) {
        var next = 0, finished = 0, pool = Math.min(8, set.count);
        function pump() {
          if (next >= set.count) return;
          var i = next++;
          loadFrame(i).then(function () {
            finished++;
            loaderBar.style.transform = 'scaleX(' + (finished / set.count) + ')';
            if (finished === set.count) done(); else pump();
          });
        }
        for (var k = 0; k < pool; k++) pump();
      });
    }

    // The gate must always open. If preloading stalls, carry on — frames keep
    // streaming and render() covers the gaps in the meantime.
    Promise.race([
      preload(),
      new Promise(function (r) { setTimeout(r, H.maxPreloadMs); })
    ]).then(function () {
      hero.classList.add('is-scrub');
      luxeRoot.style.setProperty('--hero-scroll-vh', H.scrollVh);
      document.body.classList.remove('winksleep-luxe-is-loading');
      luxeRoot.classList.remove('is-loading');
      loader.classList.add('is-done');
      setTimeout(function () { loader.hidden = true; }, 1100);

      sizeCanvas(); current = -1; render(0);

      var playhead = { frame: 0 };
      var tl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: hero, start: 'top top', end: 'bottom bottom',
          scrub: H.scrubSmoothing, invalidateOnRefresh: true,
          pin: stage, pinSpacing: false, anticipatePin: 1
        }
      });

      tl.to(playhead, {
        frame: set.count - 1, duration: 1,
        onUpdate: function () { render(Math.round(playhead.frame)); }
      }, 0);

      tl.to('#heroCue', { autoAlpha: 0, duration: 0.06, ease: 'power1.out' }, 0.01);

      function T(f) { return Math.max(0, Math.min(1, f / (H.sourceFrameCount - 1))); }
      var drift = H.captionDriftPx;

      H.captions.forEach(function (c, i) {
        var node = buildCaption(c, i);
        if (i > 0) {
          gsap.set(node, { opacity: 0 });
          if (c.fadeIn) {
            tl.fromTo(node, { opacity: 0, y: drift },
              { opacity: 1, y: 0, duration: Math.max(T(c.fadeIn[1]) - T(c.fadeIn[0]), 0.001), ease: 'power2.out' },
              T(c.fadeIn[0]));
          }
        }
        if (c.fadeOut) {
          tl.to(node, { opacity: 0, y: -drift * 0.8,
            duration: Math.max(T(c.fadeOut[1]) - T(c.fadeOut[0]), 0.001), ease: 'power2.in' }, T(c.fadeOut[0]));
        }
        // The opening tagline + arrow retire on their own, ahead of the rest.
        if (c.taglineFadeOut) {
          var row = node.querySelector('.cap__tagrow');
          if (row) {
            tl.to(row, { opacity: 0,
              duration: Math.max(T(c.taglineFadeOut[1]) - T(c.taglineFadeOut[0]), 0.001),
              ease: 'power1.out' }, T(c.taglineFadeOut[0]));
          }
        }
        if (c.cta && c.cta.fadeIn) {
          var cta = node.querySelector('.cap__cta');
          gsap.set(cta, { opacity: 0 });
          tl.fromTo(cta, { opacity: 0, y: drift },
            { opacity: 1, y: 0, duration: Math.max(T(c.cta.fadeIn[1]) - T(c.cta.fadeIn[0]), 0.001), ease: 'power2.out' },
            T(c.cta.fadeIn[0]));
        }
      });

      // Caption 0 is the landing headline, so it arrives on load rather than on
      // scroll. It animates the CHILDREN, never the .cap itself: the scroll
      // timeline owns opacity on that node and two tweens on one property fight.
      gsap.from('[data-cap="0"] > *', {
        opacity: 0, y: drift, duration: 1.4, stagger: 0.09, ease: 'power3.out', delay: 0.2
      });

      // Wipe the pointer on from its tail after the statement has landed. The
      // clip is applied here rather than in CSS so a no-JS or reduced-motion
      // visitor sees a whole arrow instead of a hidden one.
      var arrow = document.querySelector('.cap__arrow');
      if (arrow) {
        gsap.fromTo(arrow,
          { clipPath: 'inset(0% 100% 100% 0%)' },
          { clipPath: 'inset(0% 0% 0% 0%)', duration: 1, ease: 'power2.out', delay: 0.95 });
      }

      // Opening the gate grew the hero from one viewport to `scrollVh`, which
      // moved every section below it. Every other ScrollTrigger measured itself
      // before that, so without this they all fire at stale scroll positions —
      // the construction pin would engage partway up the hero.
      ScrollTrigger.refresh();

      // Set up after the refresh, so it measures against the grown hero.
      initClosingLockup(hero);

      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          sizeCanvas();
          var i = current; current = -1; render(i < 0 ? 0 : i);
          ScrollTrigger.refresh();
        }, 150);
      });
    });
  }

  /* ====================== SECTION RENDERERS ============================ */

  function renderStatementFigures() {
    // The exploded shot carries "starts from the inside" better than a packshot.
    var promise = document.querySelector('[data-figure="promise"]');
    if (promise) promise.appendChild(mediaSlot('layersAngled', '45'));
    var craft = document.querySelector('[data-figure="craft"]');
    if (craft) craft.appendChild(mediaSlot('factory', '45'));
  }

  function renderProblems() {
    var grid = document.getElementById('problemGrid');
    if (!grid) return;
    LUXE.problems.forEach(function (p) {
      var li = el('li', 'problem__item');
      li.setAttribute('data-reveal', '');
      li.innerHTML =
        '<span class="problem__fill" aria-hidden="true"></span>' +
        '<span class="problem__status" aria-hidden="true">' +
          '<span class="problem__glow"></span>' +
          '<span class="problem__before">' + (PROBLEM_ICONS[p.icon] || PROBLEM_ICONS.finder) + '</span>' +
        '</span>' +
        '<div class="problem__content">' +
          '<h3 class="problem__q">' + p.q + '</h3>' +
          '<p class="problem__a">' + p.a + '</p>' +
        '</div>';
      grid.appendChild(li);
    });
  }

  function initProblemCards() {
    var items = [].slice.call(document.querySelectorAll('.problem__item'));
    if (!items.length) return;
    if (!animate) {
      items.forEach(function (item) { item.classList.add('is-resolved'); });
      return;
    }

    items.forEach(function (item, i) {
      var fill = item.querySelector('.problem__fill');
      var before = item.querySelector('.problem__before');
      var glow = item.querySelector('.problem__glow');
      var copy = item.querySelectorAll('.problem__q, .problem__a');
      var status = item.querySelector('.problem__status');
      var startAt = 88 - Math.min(i, 3) * 4;
      var endAt = 40 - Math.min(i, 3) * 4;

      gsap.set(fill, { scaleY:0, transformOrigin:'50% 100%' });
      gsap.set(glow, { autoAlpha:0, scale:.4, transformOrigin:'50% 50%' });
      gsap.timeline({
        scrollTrigger:{
          trigger:item,
          start:'top ' + startAt + '%',
          end:'top ' + endAt + '%',
          scrub:.75,
          invalidateOnRefresh:true
        }
      })
        .to(fill, { scaleY:1, duration:1.35, ease:'power2.inOut' }, 0)
        .to(copy, { color:'#fff', duration:.6, ease:'power2.out' }, .25)
        .to(status, { color:'#fff', duration:.5, ease:'power2.out' }, .3)
        .to(glow, { autoAlpha:.46, scale:1.25, duration:.62, ease:'power2.out' }, .66)
        .to(before, { scale:1.1, filter:'drop-shadow(0 0 12px rgba(255,255,255,.88))', duration:.62, ease:'back.out(1.35)' }, .72);
    });
  }

  /* ---- 4 · Construction: pinned, scrubbed layer separation -------------- */
  function renderConstruction() {
    var stack = document.getElementById('constructionStack');
    var caps = document.getElementById('constructionCaptions');
    var dots = document.getElementById('constructionDots');
    var statik = document.getElementById('constructionStatic');
    var layers = LUXE.layers;
    if (!stack) return;

    // Static fallback content is always built — it is what reduced-motion and
    // no-GSAP visitors see, and it keeps the section meaningful either way.
    var ol = el('ol');
    layers.forEach(function (l) {
      var li = el('li');
      li.innerHTML = '<h3 class="construction__name">' + l.name + '</h3>' +
                     '<p class="construction__desc">' + l.desc + '</p>' +
                     '<p class="construction__benefit">' + l.benefit + '</p>';
      ol.appendChild(li);
    });
    statik.appendChild(ol);

    if (!animate) {
      document.getElementById('constructionPin').hidden = true;
      statik.hidden = false;
      return;
    }

    var bands = layers.map(function (l, i) {
      var band = el('div', 'construction__layer');
      band.style.zIndex = String(layers.length - i);
      // Each band is drawn at its strip's own aspect ratio, so the stack shows
      // the layers at their true relative thicknesses.
      if (l.ar) band.style.aspectRatio = String(l.ar);
      // Label first; the strip replaces it only once it has actually loaded, so
      // a missing asset shows the name rather than a broken image.
      var label = el('span', '', l.name);
      band.appendChild(label);
      if (l.src) {
        var img = new Image();
        img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
        img.style.opacity = '0';                 // in the DOM so lazy-load fires
        img.addEventListener('load', function () { label.remove(); img.style.opacity = ''; });
        img.addEventListener('error', function () { img.remove(); });
        img.src = assetUrl(l.src);
        band.appendChild(img);
      }
      stack.appendChild(band);
      return band;
    });

    layers.forEach(function (l, i) {
      var c = el('div', 'construction__caption');
      c.setAttribute('data-index', i);
      c.innerHTML = '<h3 class="construction__name">' + l.name + '</h3>' +
                    '<p class="construction__desc">' + l.desc + '</p>' +
                    '<p class="construction__benefit">' + l.benefit + '</p>';
      caps.appendChild(c);
      var d = el('li'); d.setAttribute('data-index', i); dots.appendChild(d);
    });

    var centre = (layers.length - 1) / 2;
    // Bands sit flush in normal flow (that IS the mattress). Separation just
    // pushes each one away from the middle by a share of the gap, in px, so
    // bands of different thickness all move by the same amount.
    function gapFor(i) { return (i - centre) * stack.clientWidth * LUXE.layerGap; }
    function setActive(idx) {
      caps.querySelectorAll('.construction__caption').forEach(function (n, i) {
        n.setAttribute('data-active', String(i === idx));
      });
      dots.querySelectorAll('li').forEach(function (n, i) {
        n.setAttribute('data-active', String(i === idx));
      });
      bands.forEach(function (b, i) { b.setAttribute('data-active', String(i === idx)); });
    }

    gsap.set(bands, { y: 0 });
    setActive(0);

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: '#construction', start: 'top top',
        end: function () { return '+=' + Math.round(window.innerHeight * (layers.length * 0.55 + 0.7)); },
        pin: '#constructionPin', scrub: 0.6, invalidateOnRefresh: true,
        onUpdate: function (self) {
          // Middle 60% of the scroll steps through the layers one at a time.
          var p = (self.progress - 0.2) / 0.6;
          var idx = Math.round(Math.max(0, Math.min(1, p)) * (layers.length - 1));
          setActive(idx);
        }
      }
    });
    tl.to(bands, {
      y: function (i) { return gapFor(i); },
      duration: 0.2, ease: 'power2.inOut'
    }, 0);
    tl.to(bands, { y: 0, duration: 0.2, ease: 'power2.inOut' }, 0.8);
  }

  /* ---- 5 · Hero ingredient --------------------------------------------- */
  function renderIngredient() {
    var s = document.getElementById('ingredient');
    var d = LUXE.ingredient;
    if (!s) return;
    var wrap = el('div', 'wrap');
    var grid = el('div', 'ingredient__grid');

    var media = el('div', 'ingredient__media');
    media.setAttribute('data-reveal', 'panel');
    media.appendChild(mediaSlot(d.image, '45'));

    var copy = el('div');
    copy.setAttribute('data-reveal-group', '');
    var details = d.details.map(function (p) {
      return '<dt>' + p.label + '</dt><dd>' + p.text + '</dd>';
    }).join('');
    copy.innerHTML =
      '<h2 class="section-title ingredient__name" id="ingredient-title" data-reveal="line">' + d.name + '</h2>' +
      '<dl class="ingredient__meta" data-reveal>' + details + '</dl>' +
      '<p class="ingredient__link" data-reveal><a class="ingredient__cta" href="' + d.linkHref + '" data-track="ingredient_link"><span>' + d.linkLabel + '</span><span class="ingredient__arrow" aria-hidden="true">→</span></a></p>';

    grid.appendChild(media); grid.appendChild(copy);
    wrap.appendChild(grid); s.appendChild(wrap);
  }

  function renderLifestyle() {
    var media = document.querySelector('[data-figure="lifestyle"]');
    if (media) media.appendChild(mediaSlot('lifestyle', '169'));
    initLifestyleVideo();
  }

  /* ---- Lifestyle background video ---------------------------------------
     Muted, looping, no controls and no sound anywhere. It is only fetched when
     it is genuinely worth the bytes: never on reduced motion, data-saver or
     small screens, and not until the panel is close to the viewport.

     NOTE ON WEIGHT: the source is a 4K master re-encoded with macOS avconvert,
     whose presets target quality rather than bitrate — hence ~8.6MB for 17s at
     960×540. Re-encode with ffmpeg (e.g. -crf 30 -movflags +faststart) before
     launch to get this under ~2MB, and add a WebM/AV1 source alongside it.
     --------------------------------------------------------------------- */
  function initLifestyleVideo() {
    var video = document.getElementById('lifestyleVideo');
    var V = LUXE.lifestyleVideo;
    if (!video || !V || !V.src) return;

    var conn = navigator.connection || {};
    var tooSmall = window.matchMedia('(max-width:' + V.minWidth + 'px)').matches;
    if (reduceMotion || conn.saveData === true || tooSmall) return;   // poster only

    var started = false;
    function start() {
      if (started) return;
      started = true;
      video.src = assetUrl(V.src);
      video.load();
      video.addEventListener('canplay', function () {
        video.play().then(function () {
          video.classList.add('is-playing');
        }).catch(function () {
          // Autoplay refused — leave the poster in place rather than a frozen frame.
          video.classList.remove('is-playing');
        });
      }, { once: true });
    }

    // The clip is a continuous performance, so its last frame doesn't match its
    // first. Rather than `loop` (which hard-cuts), dip the opacity across the
    // join so it reads as a soft dissolve.
    //
    // Visibility is derived from playback position every tick rather than being
    // toggled at events: that way it is self-correcting. Adding the class only
    // when a play() promise resolves would leave the panel stuck on the poster
    // if that promise ever lost a race.
    video.addEventListener('timeupdate', function () {
      if (!video.duration) return;
      var atSeam = (video.duration - video.currentTime) < V.crossfadeS;
      video.classList.toggle('is-playing', !atSeam && !video.paused && video.readyState >= 2);
    });
    video.addEventListener('ended', function () {
      video.currentTime = 0;
      video.play().catch(function () {});
    });

    var section = document.getElementById('lifestyle');
    if ('IntersectionObserver' in window && section) {
      new IntersectionObserver(function (entries, obs) {
        if (entries.some(function (e) { return e.isIntersecting; })) { start(); obs.disconnect(); }
      }, { rootMargin: '600px 0px' }).observe(section);
    } else {
      start();
    }
  }

  function renderBenefits() {
    var grid = document.getElementById('lifestyleBenefits');
    if (!grid) return;
    LUXE.benefits.forEach(function (b) {
      var li = el('li');
      li.setAttribute('data-reveal', '');
      li.innerHTML = icon(b.icon, 'benefit__icon') +
        '<h3 class="benefit__title">' + b.t + '</h3>' +
        '<p class="benefit__text">' + b.d + '</p>';
      grid.appendChild(li);
    });
  }

  /* ---- 8 · Range comparison -------------------------------------------- */
  function productCard(p) {
    var card = el('article', 'card' + (p.lead ? ' card--lead' : ''));
    card.setAttribute('data-reveal', 'panel');
    card.appendChild(el('div', 'card__campaign', 'WinkSleep LUXE'));
    var media = el('div', 'card__media');
    media.appendChild(mediaSlot(p.image || 'packshotSquare', '11'));
    card.appendChild(media);
    card.appendChild(el('div', 'card__delivery', 'Hand-built to order · Free delivery'));

    var body = el('div', 'card__body');
    body.innerHTML =
      (p.lead ? '<span class="card__badge">Most popular</span>' : '') +
      '<h3 class="card__name">WinkSleep LUXE ' + p.name + ' Mattress</h3>' +
      '<p class="card__best">' + p.best + '</p>' +
      '<img class="card__brand" src="' + assetUrl((LUXE.brand && LUXE.brand.logo) || 'BRAND.svg') + '" alt="Winksleep LUXE" width="407" height="61" loading="lazy">' +
      '<ul class="card__features">' +
        '<li>' + p.springs + ' Adaptive Core™ pocket springs</li>' +
        '<li>' + p.material + '</li>' +
        '<li>' + p.depth + ' deep · ' + p.cooling + ' cooling</li>' +
      '</ul>' +
      '<div class="card__foot">' +
        '<div><p class="card__price"><small>From</small>' + p.from + '</p>' +
        '<a class="card__link" href="' + productUrl(p) + '">View mattress →</a></div>' +
        '<span class="card__feel">' + p.feel + '</span>' +
      '</div>';
    card.appendChild(body);
    card.querySelector('.card__link').addEventListener('click', function () {
      track('comparison_opened', { productId: p.id, productName: p.name });
    });
    return card;
  }

  function promotionCard() {
    var P = LUXE.promotion;
    var href = P.href;
    if (href && href.charAt(0) === '#' && !document.getElementById(href.slice(1))) {
      href = productUrl(productById(LUXE.purchase && LUXE.purchase.productId));
    }
    var card = el('aside', 'promo-card');
    card.setAttribute('data-reveal', 'panel');
    card.setAttribute('aria-labelledby', 'promoTitle');
    card.innerHTML =
      '<img class="promo-card__badge" src="' + assetUrl(LUXE.assets.spendSaveBadge.src) + '" alt="' + LUXE.assets.spendSaveBadge.alt + '" onerror="this.remove()">' +
      '<h3 class="promo-card__title" id="promoTitle">' + P.title + '</h3>' +
      '<ul class="promo-card__tiers">' + P.tiers.map(function (tier) { return '<li>' + tier + '</li>'; }).join('') + '</ul>' +
      '<p class="promo-card__note">Savings are applied automatically at checkout.</p>' +
      '<p class="promo-card__ends">' + P.endsLabel + '</p>' +
      '<div class="promo-card__countdown" role="timer" aria-label="Time remaining in the Spend and Save offer">' +
        '<span><strong data-countdown="days">00</strong><small>days</small></span>' +
        '<span><strong data-countdown="hours">00</strong><small>hrs</small></span>' +
        '<span><strong data-countdown="minutes">00</strong><small>mins</small></span>' +
        '<span><strong data-countdown="seconds">00</strong><small>secs</small></span>' +
      '</div>' +
      '<a class="promo-card__cta" href="' + href + '">Shop now</a>';

    var target = new Date(P.endsAt).getTime();
    var interval;
    function updateCountdown() {
      var remaining = Math.max(0, target - Date.now());
      var totalSeconds = Math.floor(remaining / 1000);
      var values = {
        days:Math.floor(totalSeconds / 86400),
        hours:Math.floor((totalSeconds % 86400) / 3600),
        minutes:Math.floor((totalSeconds % 3600) / 60),
        seconds:totalSeconds % 60
      };
      Object.keys(values).forEach(function (unit) {
        var node = card.querySelector('[data-countdown="' + unit + '"]');
        if (node) node.textContent = String(values[unit]).padStart(2, '0');
      });
      if (remaining === 0) {
        clearInterval(interval);
        card.classList.add('promo-card--ended');
        card.querySelector('.promo-card__ends').textContent = 'This offer has ended';
        var cta = card.querySelector('.promo-card__cta');
        cta.removeAttribute('href');
        cta.setAttribute('aria-disabled', 'true');
      }
    }
    updateCountdown();
    if (target > Date.now()) interval = setInterval(updateCountdown, 1000);
    card.querySelector('.promo-card__cta').addEventListener('click', function () { track('promotion_clicked', { promotion:'spend_save' }); });
    return card;
  }

  function renderComparison() {
    var rail = document.getElementById('comparisonRail');
    if (!rail) return;
    LUXE.products.forEach(function (p) { rail.appendChild(productCard(p)); });
    rail.appendChild(promotionCard());
  }

  /* ---- 9 · Chooser ------------------------------------------------------ */
  function renderChooser() {
    var panel = document.getElementById('chooserPanel');
    var C = LUXE.chooser;
    if (!panel) return;

    var step = 0, answers = [], started = false;

    function progress() {
      var p = el('div', 'chooser__progress');
      C.questions.forEach(function (_, i) {
        var s = el('span'); s.setAttribute('data-done', String(i <= step)); p.appendChild(s);
      });
      return p;
    }

    function drawQuestion() {
      var q = C.questions[step];
      panel.classList.remove('chooser__panel--result');
      panel.innerHTML = '';
      panel.appendChild(progress());

      var h = el('p', 'chooser__q', q.q);
      h.id = 'chooser-q';
      panel.appendChild(h);

      var ul = el('ul', 'chooser__options');
      ul.setAttribute('role', 'group');
      ul.setAttribute('aria-labelledby', 'chooser-q');
      ul.setAttribute('data-question', q.key);
      q.options.forEach(function (opt) {
        var li = el('li');
        var b = el('button', 'chooser__option', chooserIcon(q.key, opt.label) + '<span class="chooser__option-label">' + opt.label + '</span>');
        b.type = 'button';
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          if (!started) { started = true; track('chooser_started', {}); }
          ul.querySelectorAll('.chooser__option').forEach(function (n) {
            n.setAttribute('aria-pressed', 'false');
            n.disabled = true;
          });
          b.setAttribute('aria-pressed', 'true');
          b.classList.add('is-picked');
          answers[step] = opt;
          // Sleep habits are not advertising data — see track().
          track('chooser_answer', { question: q.key, answer: opt.label, nonAdvertising: true });
          if (animate) {
            gsap.timeline()
              .to(b, { scale:0.96, duration:0.08, ease:'power2.in' })
              .to(b, { scale:1.045, duration:0.12, ease:'back.out(2)' })
              .to(b, { scale:1, duration:0.16, ease:'power2.out' });
            gsap.fromTo(b.querySelector('.chooser__option-icon'),
              { y:3, rotate:-4 },
              { y:-2, rotate:4, duration:0.18, ease:'back.out(2)', yoyo:true, repeat:1 });
          }
          setTimeout(next, animate ? 360 : 0);
        });
        li.appendChild(b); ul.appendChild(li);
      });
      panel.appendChild(ul);

      if (step > 0) {
        var back = el('button', 'chooser__back', '← Back');
        back.type = 'button';
        back.addEventListener('click', function () { step--; drawQuestion(); });
        panel.appendChild(back);
      }
      transitionIn();
      var first = panel.querySelector('.chooser__option');
      if (first) first.focus({ preventScroll: true });
    }

    function transitionIn() {
      if (!animate) return;
      gsap.fromTo(panel.children,
        { opacity: 0, y: 14, scale:.99 },
        { opacity: 1, y: 0, scale:1, duration:0.34, ease:'power3.out', stagger:0.035 });
    }

    function next() {
      if (step < C.questions.length - 1) { step++; drawQuestion(); }
      else drawResult();
    }

    function resolveRoute() {
      var route = null;
      answers.forEach(function (a) { if (a && a.route) route = a.route; });   // later answers win
      var feel = answers[2];
      if (feel && feel.route === 'firm') route = 'firm';
      else { // Q2 decides unless Q3 said Firm
        var pri = answers[1];
        if (pri && pri.route && !(feel && feel.route === 'firm')) route = pri.route;
      }
      return route || C.defaultRoute;
    }

    function drawResult() {
      var route = resolveRoute();
      var rec = C.recommendations[route];
      var main = productById(rec.product);
      var alt = productById(rec.alt);
      var isChild = answers.some(function (a) { return a && a.junior; });

      track('chooser_completed', { route: route, recommendedId: main.id, recommendedName: main.name, nonAdvertising: true });
      track('recommended_product', { productId: main.id, productName: main.name });

      panel.classList.add('chooser__panel--result');
      panel.innerHTML = '';
      var wrap = el('div', 'result');

      var media = el('div');
      media.appendChild(mediaSlot(main.image || 'packshotSquare', '11'));

      var body = el('div');
      body.innerHTML =
        '<p class="result__label">Your best match</p>' +
        '<h3 class="result__name">' + main.name + '</h3>' +
        '<ul class="result__reasons">' + rec.reasons.map(function (r) {
          return '<li>' + ICONS.tick.replace('<svg', '<svg aria-hidden="true"') + '<span>' + r + '</span></li>';
        }).join('') + '</ul>' +
        '<dl class="card__specs">' +
          '<div><dt>Feel</dt><dd>' + main.feel + '</dd></div>' +
          '<div><dt>Depth</dt><dd>' + main.depth + '</dd></div>' +
          '<div><dt>Springs</dt><dd>' + main.springs + '</dd></div>' +
          '<div><dt>Main material</dt><dd>' + main.material + '</dd></div>' +
        '</dl>' +
        '<p class="card__price"><small>From — placeholder</small>' + main.from + '</p>';

      var sizeWrap = el('div');
      // Functional form label, not a decorative eyebrow — it stays.
      sizeWrap.innerHTML = '<p class="field-label" style="margin:24px 0 12px">Choose a size</p>';
      var sizes = el('ul', 'sizes');
      var chosenSize = main.sizes[0];
      main.sizes.forEach(function (s, i) {
        var li = el('li');
        var b = el('button', 'size', s);
        b.type = 'button';
        b.setAttribute('aria-pressed', String(i === 0));
        b.addEventListener('click', function () {
          sizes.querySelectorAll('.size').forEach(function (n) { n.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          chosenSize = s;
          track('size_selected', { productId: main.id, size: s });
        });
        li.appendChild(b); sizes.appendChild(li);
      });
      sizeWrap.appendChild(sizes);

      var actions = el('div', 'purchase__actions');
      var add = el('button', 'btn', 'Add to basket');
      add.type = 'button';
      add.addEventListener('click', function () {
        track('add_to_basket', { productId: main.id, productName: main.name, size: chosenSize, source: 'chooser' });
        addToCart(main, chosenSize, 'chooser', add);
      });
      var view = el('a', 'btn btn--ghost', 'View product');
      view.href = productUrl(main);
      view.addEventListener('click', function () { track('purchase_clicked', { productId: main.id, source: 'chooser' }); });
      actions.appendChild(add); actions.appendChild(view);

      var altHref = document.getElementById('comparison') ? '#comparison' : productUrl(alt);
      var altP = el('p', 'result__alt',
        'Also worth a look: <a href="' + altHref + '">' + alt.name + '</a> — ' + alt.best +
        (isChild ? '<br><br>' + C.juniorNote : ''));

      var again = el('button', 'chooser__back', '↺ Start again');
      again.type = 'button';
      again.addEventListener('click', function () { step = 0; answers = []; drawQuestion(); });

      body.appendChild(sizeWrap); body.appendChild(actions); body.appendChild(altP); body.appendChild(again);
      wrap.appendChild(media); wrap.appendChild(body);
      panel.appendChild(wrap);
      transitionIn();
      updateStickyBar(main);
    }

    drawQuestion();
  }

  /* ---- 10 · Trustpilot testimonial carousel ---------------------------- */
  function renderProof() {
    var s = document.getElementById('proof');
    var P = LUXE.proof;
    if (!s || !P.reviews || !P.reviews.length) return;

    function stars() {
      return '<div class="review__stars" role="img" aria-label="5 out of 5 stars">' +
        '<span aria-hidden="true">★</span>'.repeat(5) + '</div>';
    }
    function card(r, duplicate) {
      var tab = duplicate ? ' tabindex="-1"' : '';
      return '<li class="review"' + (duplicate ? ' aria-hidden="true"' : '') + '>' +
        '<article>' +
          '<header class="review__author">' +
            '<img class="review__avatar" src="' + assetUrl(r.avatar) + '" alt="" width="64" height="64" loading="lazy" onerror="this.remove()">' +
            '<div><a class="review__name" href="' + r.userUrl + '" target="_blank" rel="noopener noreferrer"' + tab + '>' + r.name + '</a>' +
            '<p class="review__meta">' + r.country + ' · ' + r.count + '</p></div>' +
          '</header>' +
          stars() +
          '<a class="review__title" href="' + r.reviewUrl + '" target="_blank" rel="noopener noreferrer"' + tab + '>' + r.title + '</a>' +
          '<blockquote>' + r.quote + '</blockquote>' +
          '<footer><time>' + r.date + '</time><a href="' + r.reviewUrl + '" target="_blank" rel="noopener noreferrer"' + tab + '>Read on Trustpilot →</a></footer>' +
        '</article>' +
      '</li>';
    }

    var original = P.reviews.map(function (r) { return card(r, false); }).join('');
    var duplicates = P.reviews.map(function (r) { return card(r, true); }).join('');
    var dots = P.reviews.map(function (_, i) {
      return '<button type="button" aria-label="Show testimonial ' + (i + 1) + '" data-review-dot="' + i + '"></button>';
    }).join('');

    s.hidden = false;
    s.innerHTML = '<div class="wrap"><header class="proof__head" data-reveal-group>' +
      '<div><p class="proof__eyebrow" data-reveal>Independent customer reviews</p><h2 class="section-title" id="proof-title" data-reveal="line">Five-star sleep stories.</h2></div>' +
      '<img class="proof__logo" src="' + assetUrl(P.logo) + '" alt="Trustpilot — five stars" width="1048" height="453" loading="lazy" data-reveal onerror="this.remove()">' +
      '</header><div class="proof__carousel" id="reviewCarousel" aria-roledescription="carousel" aria-label="Customer testimonials">' +
        '<button class="proof__control proof__control--prev" type="button" aria-label="Previous testimonial">←</button>' +
        '<div class="proof__viewport" tabindex="0"><ul class="proof__reviews">' + original + duplicates + '</ul></div>' +
        '<button class="proof__control proof__control--next" type="button" aria-label="Next testimonial">→</button>' +
      '</div><div class="proof__dots">' + dots + '</div></div>';
    initReviewCarousel(s.querySelector('#reviewCarousel'), P.reviews.length, P.autoplayMs);
    track('reviews_viewed', {});
  }

  function initReviewCarousel(carousel, count, delay) {
    if (!carousel || count < 2) return;
    var viewport = carousel.querySelector('.proof__viewport');
    var trackEl = carousel.querySelector('.proof__reviews');
    var cards = trackEl.querySelectorAll('.review');
    var prev = carousel.querySelector('.proof__control--prev');
    var nextButton = carousel.querySelector('.proof__control--next');
    var dots = carousel.parentNode.querySelectorAll('[data-review-dot]');
    var index = 0, timer = null, hovering = false, inView = false;

    function distance() {
      if (!cards.length) return 0;
      var gap = parseFloat(getComputedStyle(trackEl).columnGap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function paint(withMotion) {
      trackEl.style.transition = withMotion && !reduceMotion ? 'transform 600ms cubic-bezier(.4,0,.2,1)' : 'none';
      trackEl.style.transform = 'translate3d(' + (-index * distance()) + 'px,0,0)';
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', String(i === index % count)); });
    }
    function goNext() { index++; paint(true); }
    function goPrev() {
      if (index === 0) {
        index = count;
        paint(false);
        requestAnimationFrame(function () { requestAnimationFrame(function () { index--; paint(true); }); });
      } else { index--; paint(true); }
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (!reduceMotion && inView && !hovering && !document.hidden) timer = setInterval(goNext, delay || 5000);
    }

    trackEl.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform' || index < count) return;
      index -= count;
      paint(false);
    });
    prev.addEventListener('click', function () { goPrev(); start(); });
    nextButton.addEventListener('click', function () { goNext(); start(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { index = Number(dot.getAttribute('data-review-dot')); paint(true); start(); });
    });
    carousel.addEventListener('mouseenter', function () { hovering = true; stop(); });
    carousel.addEventListener('mouseleave', function () { hovering = false; start(); });
    carousel.addEventListener('focusin', function () { hovering = true; stop(); });
    carousel.addEventListener('focusout', function (e) { if (!carousel.contains(e.relatedTarget)) { hovering = false; start(); } });
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goPrev(); start(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goNext(); start(); }
    });
    window.addEventListener('resize', function () { paint(false); });
    document.addEventListener('visibilitychange', start);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, observer) {
        inView = entries[0].isIntersecting;
        start();
        if (!document.body.contains(carousel)) observer.disconnect();
      }, { threshold:.25 }).observe(carousel);
    } else { inView = true; start(); }
    paint(false);
  }


  function renderReassurance() {
    var grid = document.getElementById('reassuranceGrid');
    if (!grid) return;
    LUXE.reassurance.forEach(function (r) {
      var li = el('li');
      li.setAttribute('data-reveal', '');
      li.innerHTML = ICONS[r.icon] + '<div><h3>' + r.t + '</h3><p>' + r.d + '</p></div>';
      grid.appendChild(li);
    });
    grid.querySelectorAll('svg').forEach(function (s) { s.setAttribute('aria-hidden', 'true'); });
  }

  /* ---- 13 · Purchase block --------------------------------------------- */
  function renderPurchase() {
    var s = document.getElementById('purchase');
    var P = LUXE.purchase;
    var p = productById(P.productId);
    if (!s || !p) return;

    var wrap = el('div', 'wrap');
    var grid = el('div', 'purchase__grid');

    var media = el('div', 'purchase__media');
    media.setAttribute('data-reveal', 'panel');
    media.appendChild(mediaSlot(p.image || 'packshotSquare', '11'));

    var body = el('div');
    body.setAttribute('data-reveal-group', '');
    body.innerHTML =
      '<span class="purchase__badge" data-reveal>' + P.badge + '</span>' +
      '<h2 class="purchase__name" id="purchase-title" data-reveal="line">' + p.name + '</h2>' +
      '<ul class="purchase__points" data-reveal>' + P.points.map(function (pt) {
        return '<li>' + ICONS.tick.replace('<svg', '<svg aria-hidden="true"') + '<span>' + pt + '</span></li>';
      }).join('') + '</ul>' +
      // PRICE BLOCK — placeholders. Replace with Shopify variant pricing.
      '<div data-reveal><p class="price"><span class="price__now">' + P.priceNow + '</span>' +
      '<span class="price__was">' + P.priceWas + '</span><span class="price__save">' + P.saving + '</span></p>' +
      '<p class="purchase__finance">' + P.finance + '</p></div>';

    var sizeWrap = el('div');
    sizeWrap.setAttribute('data-reveal', '');
    sizeWrap.innerHTML = '<p class="field-label" style="margin-bottom:12px">Choose a size</p>';
    var sizes = el('ul', 'sizes');
    var chosen = p.sizes[0];
    p.sizes.forEach(function (sz, i) {
      var li = el('li');
      var b = el('button', 'size', sz);
      b.type = 'button';
      b.setAttribute('aria-pressed', String(i === 0));
      b.addEventListener('click', function () {
        sizes.querySelectorAll('.size').forEach(function (n) { n.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        chosen = sz;
        track('size_selected', { productId: p.id, size: sz });
      });
      li.appendChild(b); sizes.appendChild(li);
    });
    sizeWrap.appendChild(sizes);

    var actions = el('div', 'purchase__actions');
    actions.setAttribute('data-reveal', '');
    var add = el('button', 'btn', 'Add to basket');
    add.type = 'button';
    add.addEventListener('click', function () {
      track('add_to_basket', { productId: p.id, productName: p.name, size: chosen, source: 'purchase_block' });
      addToCart(p, chosen, 'purchase_block', add);
    });
    var view = el('a', 'btn btn--ghost', 'See full product details');
    view.href = productUrl(p);
    view.addEventListener('click', function () { track('purchase_clicked', { productId: p.id, source: 'purchase_block' }); });
    actions.appendChild(add); actions.appendChild(view);

    var meta = el('p', 'purchase__meta', P.delivery + '<br>' + P.warranty);
    meta.setAttribute('data-reveal', '');

    body.appendChild(sizeWrap); body.appendChild(actions); body.appendChild(meta);
    grid.appendChild(media); grid.appendChild(body);
    wrap.appendChild(grid); s.appendChild(wrap);
  }

  /* ---- Shopify cart drawer --------------------------------------------- */
  var drawer = document.getElementById('cartDrawer');
  var lastFocus = null;

  function normalise(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  function variantForSize(product, size) {
    if (!product || !product.variants || !product.variants.length) return null;
    var target = normalise(size);
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.available === false) continue;
      if (normalise(v.title) === target) return v;
      if (normalise(v.title).indexOf(target) !== -1) return v;
      var opts = v.options || [];
      for (var j = 0; j < opts.length; j++) if (normalise(opts[j]) === target) return v;
    }
    return null;
  }
  function cartAddUrl() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.replace(/\/$/, '') + '/cart/add.js';
  }
  function setBusy(button, busy) {
    if (!button) return;
    if (busy) {
      button.dataset.originalText = button.textContent;
      button.textContent = 'Adding...';
      button.disabled = true;
    } else {
      button.textContent = button.dataset.originalText || button.textContent;
      button.disabled = false;
    }
  }
  function addToCart(product, size, source, button) {
    var variant = variantForSize(product, size);
    track('add_to_basket', { productId: product.id, productName: product.name, size: size, source: source, variantId: variant && variant.id });
    if (!variant || !variant.id) {
      openDrawer(product, size, { status: 'missing_variant' });
      return;
    }
    setBusy(button, true);
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (error) { throw error; });
      }
      return response.json();
    }).then(function () {
      openDrawer(product, size, { status: 'added' });
      document.dispatchEvent(new CustomEvent('winksleep:luxe-cart-added', { detail: { product: product, size: size, variant: variant } }));
    }).catch(function (error) {
      openDrawer(product, size, { status: 'error', message: error && (error.description || error.message) });
    }).finally(function () {
      setBusy(button, false);
    });
  }
  function openDrawer(product, size, state) {
    if (!drawer) return;
    state = state || { status: 'added' };
    var body = document.getElementById('drawerBody');
    var note = document.getElementById('drawerNote');
    var statusCopy = state.status === 'added'
      ? 'Added to your basket.'
      : state.status === 'missing_variant'
        ? 'This size needs a matching Shopify product variant before it can be added directly.'
        : 'Shopify could not add this item just now.';
    body.innerHTML =
      '<p><strong>' + product.name + '</strong><br>' + size + ' · ' + product.from + '</p>' +
      '<p>' + statusCopy + '</p>' +
      (state.message ? '<p>' + state.message + '</p>' : '') +
      '<p><a class="btn" href="/cart">View basket</a> <a class="btn btn--ghost" href="' + productUrl(product) + '">View product</a></p>';
    if (note) note.textContent = state.status === 'added' ? 'Your Shopify cart has been updated.' : 'Select the Shopify product in this section block to enable direct add-to-cart.';
    lastFocus = document.activeElement;
    drawer.hidden = false;
    drawer.querySelector('.drawer__close').focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    if (lastFocus) lastFocus.focus();
  }
  if (drawer) {
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (n) {
      n.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  }

  /* ---- 14 · Sticky mobile bar ------------------------------------------ */
  var stickyProduct = null;
  function scrollToSection(id) {
    var target = document.getElementById(id);
    if (!target || target.hidden) return false;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
    return true;
  }
  function updateStickyBar(product) {
    var bar = document.getElementById('stickyBar');
    if (!bar) return;
    stickyProduct = product || stickyProduct || productById(LUXE.purchase.productId);
    if (!stickyProduct) return;
    bar.innerHTML =
      '<div><p class="sticky-bar__name">' + stickyProduct.name + '</p>' +
      '<span class="sticky-bar__price">From ' + stickyProduct.from + '</span></div>';
    var canChoose = !!document.getElementById('chooser');
    var canPurchase = !!document.getElementById('purchase');
    var label = product
      ? (canPurchase ? 'Choose size' : 'View mattress')
      : (canChoose ? 'Find my mattress' : (canPurchase ? 'Choose size' : 'View mattress'));
    var b = el('button', 'btn', label);
    b.type = 'button';
    b.addEventListener('click', function () {
      track('sticky_bar_click', { productId: stickyProduct.id, hasRecommendation: !!product });
      if (scrollToSection(product ? 'purchase' : 'chooser')) return;
      if (!product && scrollToSection('purchase')) return;
      window.location.href = productUrl(stickyProduct);
    });
    bar.appendChild(b);
  }

  function initStickyBar() {
    var bar = document.getElementById('stickyBar');
    var hero = document.getElementById('hero');
    if (!bar || !hero) return;
    updateStickyBar(null);
    bar.hidden = false;

    function check() {
      var past = window.scrollY > hero.offsetHeight * 0.9;
      bar.classList.toggle('is-visible', past);
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ---- 15 · FAQ + JSON-LD ---------------------------------------------- */
  function renderFAQ() {
    var list = document.getElementById('faqList');
    if (!list) return;
    var approved = LUXE.faqs.filter(function (f) { return f.approved; });

    approved.forEach(function (f, i) {
      var item = el('div', 'faq__item');
      var btn = el('button', 'faq__q');
      btn.type = 'button';
      btn.id = 'faq-q-' + i;
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', 'faq-a-' + i);
      btn.innerHTML = '<span>' + f.q + '</span><span class="faq__icon" aria-hidden="true"></span>';

      var ans = el('div', 'faq__a');
      ans.id = 'faq-a-' + i;
      ans.setAttribute('role', 'region');
      ans.setAttribute('aria-labelledby', 'faq-q-' + i);
      ans.appendChild(el('div', '', '<p style="margin:0">' + f.a + '</p>'));

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (animate) {
          gsap.to(ans, { height: open ? 0 : 'auto', duration: 0.55, ease: 'power3.inOut' });
        } else {
          ans.style.height = open ? '0px' : 'auto';
        }
        if (!open) track('faq_opened', { question: f.q });
      });

      item.appendChild(btn); item.appendChild(ans);
      item.setAttribute('data-reveal', '');
      list.appendChild(item);
    });

    // FAQ schema — approved answers only.
    var ld = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: approved.map(function (f) {
        return { '@type': 'Question', name: f.q,
                 acceptedAnswer: { '@type': 'Answer', text: f.a } };
      })
    };
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(ld);
    document.head.appendChild(script);
  }


  /* ---- Closing lockup: opacity only; position is owned entirely by CSS -- */
  function initClosingLockup(hero) {
    var lockup = document.getElementById('closingLockup');
    var C = LUXE.hero.closing;
    if (!lockup || !hero || !animate) return;
    function framePosition(frame) {
      var heroRange = Math.max(1, hero.offsetHeight - window.innerHeight);
      return heroRange * (frame / (LUXE.hero.sourceFrameCount - 1));
    }
    gsap.fromTo(lockup,
      { opacity: 0 },
      { opacity: 1, ease: 'none', immediateRender: true,
        scrollTrigger: {
          start:function () { return framePosition(C.startFrame); },
          end:function () { return framePosition(Math.min(LUXE.hero.sourceFrameCount - 1, C.startFrame + C.fadeFrames)); },
          scrub: true, invalidateOnRefresh: true
        } });
  }

  /* ---- Smooth in-page anchors ------------------------------------------
     Done here rather than with CSS `scroll-behavior`, which interferes with
     ScrollTrigger's pinning and scroll restoration.
     --------------------------------------------------------------------- */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ====================== BOOT ========================================= */
  function boot() {
    renderStatementFigures();
    renderProblems();
    renderConstruction();
    renderIngredient();
    renderLifestyle();
    renderBenefits();
    renderComparison();
    renderChooser();
    renderProof();
    renderReassurance();
    renderPurchase();
    renderFAQ();

    if (animate) document.documentElement.classList.add('js-reveals');
    initReveals(document);
    initProblemCards();
    initHero();
    initStickyBar();
    initAnchors();

    if (hasGSAP) ScrollTrigger.refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
